<template>
  <CreateModal @closeCreateModal="resetForm" type="integration" ref="createModal">
    <v-form class="mw-700 py-5 mx-auto" ref="integrationForm" v-model="valid">
        <v-row>
            <v-col>
                <HTextInput
                    v-model="integration.apiUrl"
                    :label="$t('integration.label.apiUrl')"
                    placeholder="Digite o nome"
                    :rules="apiUrlRules"
                />
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-select
                    v-model="integration.externalSource"
                    :items="externalSources"
                    item-text="name"
                    item-value="value"
                    :label="$t('integration.label.externalSource')"
                    :rules="required"
                    filled
                ></v-select>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <HTextInput
                    v-model="integration.keyCode"
                    :label="$t('integration.label.keyCode')"
                    :rules="required"
                />
            </v-col>
        </v-row>
        <v-row v-if="integration.externalSource === 'BROGNOLI'">
            <v-col>
                <HTextInput
                    v-model="integration.apiUser"
                    :label="$t('integration.label.apiUser')"
                    :rules="required"
                />
            </v-col>
        </v-row>

        <v-row v-if="integration.externalSource === 'VISTA'">
            <v-col>
                <v-switch
                    v-model="integration.pushEnabled"
                    :label="$t('integration.label.pushEnabled')"
                    :hint="$t('integration.hint.pushEnabled')"
                    :ripple="false"
                    persistent-hint
                    inset
                />

                <span
                    v-if="integration.pushEnabled"
                    class="d-flex align-start body-2 mt-4 warning--text"
                >
                    <v-icon color="warning lighten-1" left>
                        mdi-alert-circle-outline
                    </v-icon>
                    {{ $t('integration.warnings.pushEnabled') }}
                </span>
            </v-col>
        </v-row>

        <div class="d-flex justify-end mt-15">
            <v-btn
                elevation="0"
                color="primary"
                :disabled="!valid"
                @click="newIntegration"
                :loading="isLoading"
                large
            >
                {{ $t('create.save') }}
            </v-btn>
        </div>
    </v-form>
  </CreateModal>
</template>

<script>
import CreateModal from '@/components/app/CreateModal'
import HTextInput from '@/components/app/HTextInput'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'IntegrationCreate',

    components: {
        CreateModal,
        HTextInput,
    },

    data() {
        return {
            valid: false,
            integration: {
                id: '',
                externalSource: 'VISTA',
                apiUrl: '',
                keyCode: '',
                apiUser: null,
                pushEnabled: false,
            },
            externalSources: [
                {
                    name: this.$t("integration.externalSources.VISTA"),
                    value: "VISTA"
                },
                {
                    name: this.$t("integration.externalSources.BROGNOLI"),
                    value: "BROGNOLI"
                },
            ],
            required: [(v) => (!!v && v.trim() != '') || this.$t('rules.required')],
            apiUrlRules: [
                v => !!v || this.$t('integration.rules.required'),
                v => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,10}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)*\/$/.test(v)
                || this.$t('integration.rules.apiUrl')
            ],
        }
    },
    watch: {
        integration: {
            handler(newVal, oldVal){ 
                if (newVal.externalSource != 'BROGNOLI') {
                    this.integration.apiUser = null
                }
                if (newVal.externalSource != 'VISTA') {
                    this.integration.pushEnabled = false
                }
            },
            deep: true,
        }
    },
    computed: {
        ...mapGetters(['isLoading']),
    },
    methods: {
        ...mapActions(['createIntegration']),
        ...mapMutations(['setIsLoading']),
        async newIntegration() {
            await this.createIntegration(this.buildIntegration())
            this.resetForm()
            this.$refs.createModal.closeCreateModal()
        },
        buildIntegration() {
            return {
                external_source: this.integration.externalSource,
                api_url: this.integration.apiUrl,
                key_code: this.integration.keyCode,
                api_user: this.integration.apiUser,
                push_enabled: this.integration.pushEnabled,
                enabled: true,
            }
        },
        resetForm() {
            this.integration = {
                id: '',
                externalSource: 'VISTA',
                apiUrl: '',
                keyCode: '',
                apiUser: null,
                pushEnabled: false,
            }
        },
    }
}
</script>
